const permanentBackorder = {
  loading: false,
  list: {},
}

function removeItem(list, id) {
  const { [id]: removedItem, ...rest } = list
  // console.log('Removed item', id, removedItem);
  return rest
}

const PermanentBackOrderReducer = function (state = permanentBackorder, action) {
  switch (action.type) {
    case 'TOGGLE_PERMANENT_BACKORDER_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'SET_PERMANENT_BACKORDER_LIST': {
      return {
        ...state,
        list: action.list,
      }
    }
    case 'REMOVE_PERMANENT_BACKORDER_ITEM': {
      const newList = removeItem(state.list, action.product.id)
      return {
        ...state,
        list: newList,
      }
    }
    default: {
      return state
    }
  }
}

export default PermanentBackOrderReducer
